import { useCallback } from 'react';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import { useNavigate } from '../../../hooks/useNavigate';
import { TabsNav as TabsNavBase } from '../../common/TabsNav';
import type { TabValue } from '../../common/TabsNav/TabsNav';
import { useMergedSurveyViewExperiment } from '../hooks/useMergedSurveyViewExperiment';

const surveyTabs = [
  {
    label: 'tabsnav.surveys.responses',
    value: 'responses',
  },
  {
    label: 'tabsnav.surveys.results',
    value: 'results',
  },
  {
    label: 'tabsnav.surveys.performance',
    value: 'performance',
  },
] as const;

const variantSurveyTabs = [
  {
    label: 'tabsnav.surveys.results',
    value: 'results',
  },
  {
    label: 'tabsnav.surveys.performance',
    value: 'performance',
  },
] as const;

type SurveyTabValue = TabValue<typeof surveyTabs>;

export interface TabsNavProps {
  siteId: number | undefined;
  surveyId: number | undefined;
  selectedValue: SurveyTabValue;
}

export function TabsNav({ siteId, surveyId, selectedValue }: TabsNavProps): JSX.Element {
  const isInMergedViewExperiment = useMergedSurveyViewExperiment();
  const navigate = useNavigate();
  const onTabClick = useCallback(
    (tab: SurveyTabValue) => {
      if (siteId === undefined || surveyId === undefined) return;
      const stateParams = { siteId, surveyId };
      if (tab === 'responses') navigate(SURVEYS.RESPONSES.path, stateParams, true);
      if (tab === 'results') navigate(SURVEYS.RESULTS.path, stateParams, true);
      if (tab === 'performance') navigate(SURVEYS.PERFORMANCE.path, stateParams, true);
    },
    [navigate, siteId, surveyId],
  );
  if (!isInMergedViewExperiment)
    return <TabsNavBase tabs={surveyTabs} onTabClick={onTabClick} selectedValue={selectedValue} />;
  return (
    <TabsNavBase
      tabs={variantSurveyTabs}
      onTabClick={onTabClick}
      selectedValue={selectedValue === 'responses' ? 'results' : selectedValue}
    />
  );
}
